import { gql } from '@apollo/client'

export const CLUB_TEES_QUERY = gql`
  query ClubTees($clubId: ID!) {
    clubTees(clubId: $clubId) {
      id
      name
      color
      slopeRating
      courseRating
      par
      totalDistance
      courseId
      typeId
      createdAt
      updatedAt
    }
  }
`

export const UPDATE_TEE_MUTATION = gql`
  mutation UpdateTee($input: UpdateTeeInput!) {
    updateTee(input: $input) {
      id
      name
      color
      slopeRating
      courseRating
      par
      totalDistance
      courseId
      typeId
      createdAt
      updatedAt
    }
  }
`

export const CREATE_TEE_MUTATION = gql`
  mutation CreateTee($input: CreateTeeInput!) {
    createTee(input: $input) {
      id
      name
      color
      slopeRating
      courseRating
      par
      totalDistance
      courseId
      typeId
      createdAt
      updatedAt
    }
  }
`

export const DELETE_TEE_MUTATION = gql`
  mutation DeleteTee($clubId: ID!, $id: ID!) {
    deleteTee(clubId: $clubId, id: $id)
  }
`
